module.exports = __webpack_public_path__ + "img/output-token.e14c2b93.svg";